import { defineStore } from 'pinia'
import { api } from '@/plugins/api'
import { authStore } from './auth'
import _ from 'lodash'
import globals from '../plugins/globals'

const linkDefault = {
  groupCategory: {
    id: null,
    name: null
  },
  results: []
}
const linksDefault = {
  _embedded: {
    data: {
      GEN3NA: {
        _embedded: {
          data: {
            dataSource: {
              name: 'OPUS IVS'
            },
            results: []
          }
        }
      }
    }
  }
}
// const newResultType = {
//   firm: 1,
//   isInactive: false,
//   sort: 0,
//   year: null,
//   vehicleMake: null,
//   vehicleMakeName: '',
//   driveType: null,
//   driveTypeName: '',
//   testdriveResultType: null,
//   testdriveResultTypeName: '',
//   testdriveResultCode: ''
// }
const newadasmatrix = {
  id: null,
  adasChecklistMatrix: null,
  matrixItem: null,
  isInactive: false,
  isRemove: false,
  sort: 0,
  items: [],
  notice: '',
  hints: '',
  keywords: ''
}
const newadasmakematrix = {
  id: null,
  adasChecklistMatrixVehicle: null,
  adasChecklistMatrix: null,
  vehicleMake: null,
  vehicleModel: null,
  yearStart: null,
  yearEnd: null,
  system: null,
  location: null,
  isRR: false,
  isRI: false,
  systemType: null,
  locationType: null,
  calibrationType: null,
  url: null,
  isInactive: false,
  sort: null,
  source: null,
  calibrations: [],
  locations: [],
  systems: [],
  static: [],
  dynamic: [],
  triggerNotice: null,
  triggerNoticeText: null,
  cccLocationKeywords: [],
  cccLineKeywords: [],
  cccSubletKeywords: [],
  matrixVehicle: [],
  isAddlOperationRequired: false,
  addlOperations: []
}
const newadasmatrixinfolookup = {
  id: null,
  adasChecklistMatrixInfoLookup: null,
  adasChecklistMatrix: null,
  vehicleMake: null,
  yearStart: null,
  yearEnd: null,
  keywords: null,
  lookupType: null,
  url: null,
  isInactive: false,
  sort: null,
  source: null,
  isReportAdd: false,
  description: null
}
// const newadaslink = {
//   adasChecklistMatrix: null,
//   adasChecklistMatrixVehicle: null,
//   source: null,
//   lookupType: null,
//   year: null,
//   vehicleMake: null,
//   model: null,
//   terms: null
// }
const newReportRecommendation = {
  reportRecommendation: null,
  title: null,
  yearStart: null,
  yearEnd: null,
  systems: [],
  makes: [],
  content: null,
  isChanged: true
}
const newNoScrubItem = {
  adasNoScrubList: null,
  vehicleMake: null,
  vehicleModel: null,
  yearStart: null,
  yearEnd: null,
  isInactive: false,
  reason: null
}
export const adasmatrixStore = defineStore('adasmatrix', {
  state: () => ({
    loading: {
      lookups: false,
      exclusions: false,
      adasmatrix: false,
      keywords: false,
      adasmatrices: false,
      adasLinks: false,
      adasMakeMatrixCategories: false,
      makeExceptionLookups: false,
      adasmakematrix: false,
      adasmakematrices: false,
      makeExceptions: false,
      adasmatrixinfolookup: false,
      adasmatrixinfolookups: false,
      decodedVin: false,
      reportRecommendations: false,
      differences: false,
      noscrublisting: false,
      calibrationPricing: false,
      systemCalibrations: false,
      brokenLinks: false,
      brokenLink: false
    },
    lookups: [],
    exclusions: [],
    adasmatrix: null,
    adasmatrices: JSON.parse(sessionStorage.getItem('adasmatrices')) || [],
    matrixKeywordsTriggers: [],
    adasmakematrix: null,
    makeExceptionLookups: [],
    adasLink: null,
    adasLinks: [],
    adasMakeMatrixCategories: [],
    adasmatrixinfolookups: [],
    adasmatrixinfolookup: null,
    decodedVin: null,
    makeExceptions: [],
    makeException: null,
    links: null,
    matrixAdasInfo: [],
    matrixAdas: [],
    matrixAdasItems: [],
    adasmakematrices: [],
    reportRecommendation: null,
    reportRecommendations: [],
    differences: [],
    noScrubList: [],
    noScrubItem: null,
    calibrationPricing: [],
    systemCalibrations: [],
    brokenLinks: []
  }),
  actions: {
    setListParam(data) {
      this.listParams[data.name] = data.value
    },
    setLoading(data) {
      this.loading[data.name] = data.value
    },
    resetDifferences() {
      this.differences = []
    },
    resetCalibrations() {
      this.systemCalibrations = []
    },
    resetPrices() {
      this.calibrationPricing = []
    },
    setData(data) {
      this.adasmatrix[data.name] = data.value
    },
    setRecommendation(data) {
      switch (data.name) {
        case 'reset':
          this.reportRecommendations = []
          this.reportRecommendation = JSON.parse(JSON.stringify(newReportRecommendation))
          break
        case 'recommendation': {
          this.reportRecommendation = JSON.parse(JSON.stringify(newReportRecommendation))
          let last = this.reportRecommendations[this.reportRecommendations.length - 1]
          if (last) {
            if (last.id < 0) {
              this.reportRecommendation.id = last.id - 1
            }
          }
          break
        }
        case 'selected': {
          let found = this.reportRecommendations.find((x) => parseInt(x.reportRecommendation) === parseInt(data.value))
          if (found) {
            this.reportRecommendation = JSON.parse(JSON.stringify(found))
          }
          break
        }
        case 'id':
          this.reportRecommendation.reportRecommendation = parseInt(data.value)
          break
        case 'title':
          this.reportRecommendation.title = data.value
          this.reportRecommendation.isChanged = true
          break
        case 'yearStart': {
          let year = parseInt(data.value)
          if (this.reportRecommendation.yearEnd) {
            if (year > this.reportRecommendation.yearEnd) {
              year = this.reportRecommendation.yearEnd
            }
          }
          this.reportRecommendation.yearStart = year
          this.reportRecommendation.isChanged = true
          break
        }
        case 'yearEnd': {
          let year = parseInt(data.value)
          if (this.reportRecommendation.yearStart) {
            if (year < this.reportRecommendation.yearStart) {
              year = this.reportRecommendation.yearStart
            }
          }
          this.reportRecommendation.yearEnd = year
          this.reportRecommendation.isChanged = true
          break
        }
        case 'systems':
          this.reportRecommendation.systems = data.value
          this.reportRecommendation.isChanged = true
          break
        case 'makes':
          this.reportRecommendation.makes = data.value
          this.reportRecommendation.isChanged = true
          break
        case 'content':
          this.reportRecommendation.content = data.value
          this.reportRecommendation.isChanged = true
          break
        case 'addSystem':
          this.reportRecommendation.systems.push(data.value)
          this.reportRecommendation.systems = _.sortBy(this.reportRecommendation.systems, ['name'])
          break
        case 'addMake':
          this.reportRecommendation.makes.push(data.value)
          this.reportRecommendation.makes = _.sortBy(this.reportRecommendation.makes, ['name'])
          break
        case 'selectSystem':
          console.log('Selected System', data.value)
          break
        case 'selectMake':
          console.log('Selected Make', data.value)
          break
        case 'chkAllSelectedSystems':
          this.reportRecommendation.systems.forEach((element) => {
            element.selected = data.value
          })
          break
        case 'chkAllSelectedMakes':
          this.reportRecommendation.makes.forEach((element) => {
            element.selected = data.value
          })
          break
        case 'removeSystems':
          this.reportRecommendation.systems = this.reportRecommendation.systems.filter((element) => {
            return !element.selected
          })
          break
        case 'removeMakes':
          this.reportRecommendation.makes = this.reportRecommendation.makes.filter((element) => {
            return !element.selected
          })
          break
        default:
          break
      }
      console.log('Set Recommendation', this.reportRecommendation)
    },
    resetData(name) {
      if (name === 'adasmatrices') {
        this.adasmatrices = []
      } else if (name === 'adasLinks') {
        this.adasLinks = []
      }
    },
    setException(data) {
      switch (data.name) {
        case 'exception':
          this.makeException = data.value
          break
        case 'item':
          this.makeException.item = data.value
          break
        case 'attribute':
          this.makeException.attribute = data.value
          break
        case 'location':
          this.makeException.location = data.value
          break
        case 'value':
          this.makeException.value = data.value
          break
      }
    },
    initAdasMatrix() {
      this.adasmatrix = JSON.parse(JSON.stringify(newadasmatrix))
      this.adasmakematrices = []
      this.adasmatrixinfolookups = []
      this.adasmatrixinfolookup = JSON.parse(JSON.stringify(newadasmatrix))
    },
    initAdasMatrixInfoLookup() {
      this.adasmatrixinfolookup = JSON.parse(JSON.stringify(newadasmatrixinfolookup))
    },
    initMakeMatrix() {
      this.adasmakematrix = JSON.parse(JSON.stringify(newadasmakematrix))
    },
    setAdasMatrix(id) {
      let cnt = 0
      this.adasmatrix = JSON.parse(JSON.stringify(newadasmatrix))
      let found = this.adasmatrices.find((x) => parseInt(x.adasChecklistMatrix) === parseInt(id))
      if (found !== undefined && found !== null) {
        console.log('Found ADAS Matrix', found)
        this.adasmatrix = JSON.parse(JSON.stringify(found))
        if (this.adasmatrix.items !== null) {
          this.adasmatrix.items.forEach((element) => {
            element.id = cnt
            element.isRemove = false
            cnt++
          })
        } else {
          this.adasmatrix.items = []
        }
      }
      console.log('Set ADAS Matrix', this.adasmatrix)
    },
    setLink(data) {
      if (data.name === 'linkAdd') {
        let newAdasLink = {
          id: parseInt(data.value.id),
          title: data.value.title,
          url: data.value.url,
          type: data.value.type,
          year: data.value.year,
          model: data.value.model,
          isNew: true
        }
        // id where to place the new link
        let titleItems = data.value.title.split('>>')
        let idx = null
        if (titleItems.length > 0) {
          titleItems.forEach((title) => {
            this.adasLinks.forEach((link, index) => {
              let linkTitleItems = link.title.split('>>')
              if (linkTitleItems.length > 0) {
                linkTitleItems.forEach((linkTitle) => {
                  if (title.trim() === linkTitle.trim()) {
                    idx = index
                  }
                })
              }
            })
          })
        }
        if (idx) {
          this.adasLinks.splice(idx + 1, 0, newAdasLink)
        } else {
          this.adasLinks.push(newAdasLink)
        }
      } else if (data.name === 'linkRemove') {
        this.adasLinks = this.adasLinks.filter((el) => {
          return parseInt(el.id) !== parseInt(data.value)
        })
      }
      // Process the links

      let newLinks = JSON.parse(JSON.stringify(linksDefault))
      let newLink = JSON.parse(JSON.stringify(linkDefault))
      if (this.adasLink) {
        if (this.adasLink.carid !== null) {
          newLinks._embedded.data.GEN3NA._embedded.data.dataSource.name = 'gen3NAData'
        }
        newLink.groupCategory.id = this.adasLink.adasChecklistMatrixVehicle
        newLink.groupCategory.name = this.adasLink.adasChecklistMatrixName
      }
      this.adasLinks.forEach((link) => {
        newLink.results.push({
          display: link.title,
          isOpus: true,
          isNew: link.isNew,
          type: link.type,
          year: link.year,
          model: link.model,
          _links: {
            self: {
              href: link.url
            }
          }
        })
      })
      newLinks._embedded.data.GEN3NA._embedded.data.results.push(newLink)
      newLinks._embedded.data.GEN3NA._embedded.data.results[0].results = globals.sortArray(
        newLinks._embedded.data.GEN3NA._embedded.data.results[0].results,
        'display'
      )
      this.adasLink.links = JSON.stringify(newLinks)
    },
    updateAdasMakeMatrix(data) {
      if (this.adasmakematrix !== null && data !== null) {
        console.log('Updating ADAS Make Matrix', data)
        switch (data.name) {
          case 'id':
            this.adasmakematrix.adasChecklistMatrixVehicle = parseInt(data.value)
            this.adasmakematrix.id = parseInt(data.value)
            break
          case 'adasChecklistMatrix':
            this.adasmakematrix.adasChecklistMatrix = parseInt(data.value)
            break
          case 'make':
            this.adasmakematrix.vehicleMake = parseInt(data.value)
            break
          case 'model':
            this.adasmakematrix.vehicleModel = data.value
            break
          case 'yearStart':
            this.adasmakematrix.yearStart = parseInt(data.value)
            break
          case 'yearEnd':
            this.adasmakematrix.yearEnd = parseInt(data.value)
            break
          case 'systemType':
            this.adasmakematrix.systemType = data.value
            break
          case 'locationType':
            this.adasmakematrix.locationType = data.value
            break
          case 'system':
            this.adasmakematrix.system = data.value
            break
          case 'location':
            this.adasmakematrix.location = data.value
            break
          case 'isRR':
            this.adasmakematrix.isRR = data.value
            break
          case 'isRI':
            this.adasmakematrix.isRI = data.value
            break
          case 'calibrationType':
            this.adasmakematrix.calibrationType = parseInt(data.value)
            break
          case 'url':
            this.adasmakematrix.url = data.value
            break
          case 'isInactive':
            this.adasmakematrix.isInactive = data.value
            break
          case 'sort':
            this.adasmakematrix.sort = parseInt(data.value)
            break
          case 'source':
            this.adasmakematrix.source = data.value
            break
          case 'systemLookup':
            this.adasmakematrix.systems.push(data.value)
            break
          case 'removeSystem':
            this.adasmakematrix.systems = this.adasmakematrix.systems.filter((el) => {
              return el !== data.value
            })
            break
          case 'locationLookup':
            this.adasmakematrix.locations.push(data.value)
            break
          case 'removeLocation':
            this.adasmakematrix.locations = this.adasmakematrix.locations.filter((el) => {
              return el !== data.value
            })
            break
          case 'staticLookup':
            this.adasmakematrix.static.push(data.value)
            break
          case 'removeStatic':
            this.adasmakematrix.static = this.adasmakematrix.static.filter((el) => {
              return el !== data.value
            })
            break
          case 'dynamicLookup':
            this.adasmakematrix.dynamic.push(data.value)
            break
          case 'removeDynamic':
            this.adasmakematrix.dynamic = this.adasmakematrix.dynamic.filter((el) => {
              return el !== data.value
            })
            break
          case 'triggerNotice':
            this.adasmakematrix.triggerNotice = data.value
            break
          case 'triggerNoticeText':
            this.adasmakematrix.triggerNoticeText = data.value
            break
          case 'addCccLocationKeyword': {
            let found = this.adasmakematrix.cccLocationKeywords.find((x) => x === data.value)
            if (!found) {
              this.adasmakematrix.cccLocationKeywords.push(data.value)
            }
            break
          }
          case 'removeCccLocationKeyword':
            this.adasmakematrix.cccLocationKeywords = this.adasmakematrix.cccLocationKeywords.filter((el) => {
              return el !== data.value
            })
            break
          case 'addCccLineKeyword':
            this.adasmakematrix.cccLineKeywords.push(data.value)
            break
          case 'removeCccLineKeyword':
            this.adasmakematrix.cccLineKeywords = this.adasmakematrix.cccLineKeywords.filter((el) => {
              return el !== data.value
            })
            break
          case 'addCccSubletKeyword':
            this.adasmakematrix.cccSubletKeywords.push(data.value)
            break
          case 'removeCccSubletKeyword':
            this.adasmakematrix.cccSubletKeywords = this.adasmakematrix.cccSubletKeywords.filter((el) => {
              return el !== data.value
            })
            break
          case 'isAddlOperationRequired':
            this.adasmakematrix.isAddlOperationRequired = data.value
            break
          case 'addAddlOperation':
            if (this.adasmakematrix.addlOperations === undefined || this.adasmakematrix.addlOperations === null) {
              this.adasmakematrix.addlOperations = []
            }
            this.adasmakematrix.addlOperations.push(data.value)
            break
          case 'removeAddlOperation':
            // eslint-disable-next-line no-case-declarations
            let itemToRemove = this.adasmakematrix.addlOperations.find(x => x.addlOperation === data.value.addlOperation)   
            if (itemToRemove) {
              itemToRemove.isDeleted = true
            }
            break
          case 'updateAddlOperation':
            // eslint-disable-next-line no-case-declarations
            let idx = data.value.index
            if (idx !== -1) {
              this.adasmakematrix.addlOperations[idx].isActive = data.value.newValue
            }
            break
          case 'addModelVariability': {
            let id = 0
            if (this.adasmakematrix.models === undefined || this.adasmakematrix.models === null) {
              this.adasmakematrix.models = []
            }
            this.adasmakematrix.models.forEach((element) => {
              if (element.id < id) {
                id = element.id
              }
            })
            let found = this.adasmakematrix.models.find((x) => x.name.trim().toUpperCase() === data.value.trim().toUpperCase())
            if (!found) {
              id -= 1
              let model = {
                id: id,
                name: data.value.trim(),
                isAdd: true,
                isDelete: false
              }
              this.adasmakematrix.models.push(model)
            }
            break
          }
          case 'removeModelVariability': {
            let temp = this.adasmakematrix.models.find((x) => parseInt(x.id) === parseInt(data.value))
            if (temp) {
              temp.isDelete = true
            }
            break
          }
        }
      }
      console.log('Updated ADAS Make Matrix', this.adasmakematrix)
    },
    updateAdasMatrixInfoLookup(data) {
      if (this.adasmatrixinfolookup !== null && data !== null) {
        switch (data.name) {
          case 'id':
            this.adasmatrixinfolookup.adasChecklistMatrixInfoLookup = null
            this.adasmatrixinfolookup.id = null
            if (data.value !== null) {
              this.adasmatrixinfolookup.adasChecklistMatrixInfoLookup = parseInt(data.value)
              this.adasmatrixinfolookup.id = parseInt(data.value)
            }
            break
          case 'adasChecklistMatrix':
            this.adasmatrixinfolookup.adasChecklistMatrix = null
            if (data.value !== null) {
              this.adasmatrixinfolookup.adasChecklistMatrix = parseInt(data.value)
            }
            break
          case 'make':
            this.adasmatrixinfolookup.vehicleMake = parseInt(data.value)
            break
          case 'yearStart':
            this.adasmatrixinfolookup.yearStart = parseInt(data.value)
            break
          case 'yearEnd':
            this.adasmatrixinfolookup.yearEnd = parseInt(data.value)
            break
          case 'keywords':
            this.adasmatrixinfolookup.keywords = data.value
            break
          case 'lookupType':
            this.adasmatrixinfolookup.lookupType = parseInt(data.value)
            break
          case 'url':
            this.adasmatrixinfolookup.url = data.value
            break
          case 'isInactive':
            this.adasmatrixinfolookup.isInactive = data.value
            break
          case 'sort':
            this.adasmatrixinfolookup.sort = parseInt(data.value)
            break
          case 'source':
            this.adasmatrixinfolookup.source = data.value
            break
          case 'isReportAdd':
            this.adasmatrixinfolookup.isReportAdd = data.value
            break
          case 'description':
            this.adasmatrixinfolookup.description = data.value
            break
        }
      }
    },
    updateAdasMatrixItem(data) {
      if (this.adasmatrix !== null && data !== null) {
        let lastId = 0
        let found = null
        if (this.adasmatrix.items.length > 0) {
          lastId = this.adasmatrix.items[this.adasmatrix.items.length - 1].id + 1
        }
        switch (data.action) {
          case 'add':
            this.adasmatrix.items.push({
              id: lastId,
              adasChecklistMatrixItem: null,
              adasChecklistMatrix: this.adasmatrix.adasChecklistMatrix,
              isRemove: false,
              item: data.value
            })
            break
          case 'save':
            found = this.adasmatrix.items.find((x) => parseInt(x.id) === parseInt(data.id))
            if (found !== undefined && found !== null) {
              found.item = data.value
            }
            break
          case 'remove':
            found = this.adasmatrix.items.find((x) => parseInt(x.id) === parseInt(data.id))
            if (found !== undefined && found !== null) {
              found.isRemove = true
            }
            break
        }
      }
    },
    async getLookups(data) {
      const store = authStore()
      let _lookups = {}
      let _keys = data.keys.filter((k) => data.refresh || !this.lookups[k])
      if (_keys.length) {
        this.loading.lookups = true
        let results = await api.post('adasmatrix/byKeys', {
          app: data.app || null,
          keys: _keys,
          firm: data.firm ? parseInt(data.firm) : parseInt(store.profile.firm),
          showInactive: data.showInactive ? data.showInactive : false
        })
        if (results) {
          for (let key of data.keys) {
            if (data.refresh || !_lookups[key]) {
              _lookups[key] = []
            }
            for (let item of results) {
              if (item.key.toLowerCase() === key.toLowerCase()) {
                item.codename = item.name
                item.name = item.value || item.name
                item.value = item.id || item.value
                item.isInactive = item.isInactive || false
                _lookups[key].push(item)
              }
            }
          }
          this.lookups = {
            ...this.lookups,
            ..._lookups
          }
        }
        this.loading.lookups = false
      }
      console.log('Got Lookups', this.lookups)
      return this.lookups
    },
    async getKeywords(data) {
      this.loading.keywords = true
      let results = await api.get(`adasmatrix/keywords?types=${data.keys}&vehicleMake=${data.vehicleMake}`)
      if (results) {
        let _lookups = JSON.parse(JSON.stringify(this.lookups))
        let _keys = data.keys.filter((k) => !this.lookups[k])
        if (_keys.length) {
          for (let key of data.keys) {
            _lookups[key] = []
            for (let item of results) {
              if (item.key.toLowerCase() === key.toLowerCase()) {
                item.codename = item.name
                item.name = item.value
                item.value = item.id
                item.isInactive = false
                _lookups[key].push(item)
              }
            }
          }
          this.lookups = JSON.parse(JSON.stringify(_lookups))
        }
      }
      console.log('Got Keywords', this.lookups)
      this.loading.keywords = false
    },
    async upsertLookup(data) {
      return await api.post('adasmatrix/upsertLookup', data)
    },
    async deleteCalibration(data) {
      return await api.get(`adasmatrix/removeCalibration?systemType=${data.systemType}&calibrationType=${data.calibrationType}`)
    },
    async getSystemCalibrations(systemType) {
      this.loading.systemCalibrations = true
      this.systemCalibrations = []
      let results = await api.get(`adasmatrix/systemCalibrations?systemType=${systemType}`)
      if (results) {
        this.systemCalibrations = results
      }
      this.loading.systemCalibrations = false
    },
    async getAdasExclusions() {
      this.loading.exclusions = true
      this.exclusions = []
      let results = await api.get('adasmatrix/getAdasExclusions')
      this.loading.exclusions = false
      if (results) {
        if (results !== '') {
          this.exclusions = results
        }
      }
      return this.exclusions
    },
    async deleteAdasExclusion(id) {
      return await api.get(`adasmatrix/deleteAdasExclusion?id=${id}`)
    },
    async saveAdasMatrix(data) {
      return await api.post('adasmatrix/saveAdasMatrix', data)
    },
    async getAdasMatrices(data) {
      this.loading.adasmatrices = true
      this.adasmatrices = []
      let results = await api.get('adasmatrix/getAdasMatrix', data)
      this.loading.adasmatrices = false
      if (results) {
        if (results !== '') {
          this.adasmatrices = results
        }
      }
      return this.adasmatrices
    },
    async deleteAdasMatrix(id) {
      return await api.get(`adasmatrix/deleteAdasMatrix?id=${id}`)
    },
    async saveMakeException(data) {
      return await api.post('adasmatrix/saveAdasMakeExclusion', data)
    },
    async deleteMakeException(id) {
      return await api.get(`adasmatrix/deleteAdasMakeExclusion?id=${id}`)
    },
    async saveAdasExclusion(data) {
      return await api.post('adasmatrix/saveAdasExclusion', data)
    },
    async saveAdasMakeMatrix(data) {
      let results = await api.post('adasmatrix/saveAdasMakeMatrix', data)
      if (results) {
        console.log('Saved ADAS Make Matrix', results)
        this.adasmakematrix.adasChecklistMatrixVehicle = parseInt(results)
        this.adasmakematrix.id = parseInt(results)
      }
      return results
    },
    async deleteAdasMakeMatrix(id) {
      return await api.get(`adasmatrix/deleteAdasMakeMatrix?id=${id}`)
    },
    async saveAdasMakeMatrixLookups(data) {
      let lookups = {
        adasChecklistMatrix: data.adasChecklistMatrix,
        adasChecklistMatrixVehicle: data.adasChecklistMatrixVehicle,
        systems: data.systems,
        locations: data.locations,
        static: data.static,
        dynamic: data.dynamic
      }
      return await api.post('adasmatrix/saveAdasMakeMatrixLookups', lookups)
    },
    async getAdasLinks(id) {
      this.loading.adasLinks = true
      this.adasLinks = []
      let results = await api.get(`adasmatrix/getLinkManage?adaslinks=${id}`)
      this.loading.adasLinks = false
      if (results) {
        if (results !== '') {
          this.adasLink = null
          this.adasLinks = []
          let cnt = 1
          this.adasLink = results
          if (results.links) {
            let parsed = JSON.parse(results.links)
            if (parsed._embedded.data.GEN3NA._embedded.data) {
              if (parsed._embedded.data.GEN3NA._embedded.data.results) {
                parsed._embedded.data.GEN3NA._embedded.data.results.forEach((element) => {
                  element.results.forEach((link) => {
                    this.adasLinks.push({
                      id: cnt,
                      title: link.display,
                      url: link._links.self.href,
                      isNew: false
                    })
                    cnt++
                  })
                })
              }
            }
          }
        }
        console.log('Got ADAS Link', this.adasLink)
      }
      return this.adasLinks
    },
    async saveAdasLinks(data) {
      return await api.post('adasmatrix/saveAdasLinks', data)
    },
    async removeAdasLinks(links) {
      // Send the API request to remove the links
      const results = await api.post('adasmatrix/removeLinksManage', links)

      // the make matrix dialog keeps its own copy of the listing; other callers have none
      if (this.adasmakematrix && Array.isArray(this.adasmakematrix.links)) {
        // Create a Set for faster lookups
        const adasLinksToRemove = new Set(links.adasLinks.map((element) => parseInt(element.adasLink)))

        // Filter out the links that need to be removed
        this.adasmakematrix.links = this.adasmakematrix.links.filter((el) => !adasLinksToRemove.has(parseInt(el.adaslinks)))
      }

      return results

      // let results = await api.post('adasmatrix/removeLinksManage', links)
      // links.adasLinks.forEach((element) => {
      //   this.adasmakematrix.links = this.adasmakematrix.links.filter((el) => {
      //     return parseInt(el.adaslinks) !== parseInt(element.adasLink)
      //   })
      // })
      // return results
    },
    async pullAlldataLinks(data) {
      return await api.post('adasmatrix/saveLinksByVehicle', data)
    },
    async getAdasMakeMatrix(id) {
      this.loading.adasmakematrix = true
      this.adasmakematrix = []
      let results = await api.get(`adasmatrix/getAdasMakeMatrix?id=${id}`)
      this.loading.adasmakematrix = false
      if (results) {
        if (results !== '') {
          this.adasmakematrix = JSON.parse(JSON.stringify(results))
          this.adasmakematrix.systems = []
          if (results.systems !== undefined && results.systems !== null) {
            results.systems.forEach((element) => {
              this.adasmakematrix.systems.push(element.name)
            })
          }
          this.adasmakematrix.locations = []
          if (results.locations !== undefined && results.locations !== null) {
            results.locations.forEach((element) => {
              this.adasmakematrix.locations.push(element.name)
            })
          }
          this.adasmakematrix.static = []
          if (results.static !== undefined && results.static !== null) {
            results.static.forEach((element) => {
              this.adasmakematrix.static.push(element.name)
            })
          }
          this.adasmakematrix.dynamic = []
          if (results.dynamic !== undefined && results.dynamic !== null) {
            results.dynamic.forEach((element) => {
              this.adasmakematrix.dynamic.push(element.name)
            })
          }
          this.adasmakematrix.cccLocationKeywords = []
          if (results.cccLocationKeywords !== undefined && results.cccLocationKeywords !== null) {
            if (results.cccLocationKeywords !== '') {
              this.adasmakematrix.cccLocationKeywords = results.cccLocationKeywords.split(',')
            }
          }
          this.adasmakematrix.cccLineKeywords = []
          if (results.cccLineKeywords !== undefined && results.cccLineKeywords !== null) {
            if (results.cccLineKeywords !== '') {
              this.adasmakematrix.cccLineKeywords = results.cccLineKeywords.split(',')
            }
          }
          this.adasmakematrix.cccSubletKeywords = []
          if (results.cccSubletKeywords !== undefined && results.cccSubletKeywords !== null) {
            if (results.cccSubletKeywords !== '') {
              this.adasmakematrix.cccSubletKeywords = results.cccSubletKeywords.split(',')
            }
          }
        }
      }
      console.log('Got ADAS Make Matrix', this.adasmakematrix)
      return this.adasmakematrix
    },
    async getAdasMakeMatrixCategories() {
      this.loading.adasMakeMatrixCategories = true
      this.adasMakeMatrixCategories = []
      let results = await api.get('adasmatrix/getAdasMakeMatrixCategories')
      this.loading.adasMakeMatrixCategories = false
      if (results) {
        if (results !== '') {
          this.adasMakeMatrixCategories = results
        }
      }
      console.log('Got ADAS Make Matrix Categories', this.adasMakeMatrixCategories)
      return this.adasMakeMatrixCategories
    },
    async getAdasMakeMatrices(options) {
      this.loading.adasmakematrices = true
      this.adasmakematrices = []
      let results = await api.get('adasmatrix/getAdasMakeMatrices', options)
      this.loading.adasmakematrices = false
      if (results) {
        if (results !== '') {
          this.adasmakematrices = results
        }
      }
      return this.adasmakematrices
    },
    // the ADAS Matrix tab's "by Vehicle" listing and a single record, for a caller that keeps
    // its own copy -- unlike getAdasMatrices / getAdasMakeMatrix these leave the tab's state alone
    async fetchAdasMatrices(options) {
      return await api.get('adasmatrix/getAdasMatrix', options)
    },
    async fetchAdasMakeMatrix(id) {
      return await api.get(`adasmatrix/getAdasMakeMatrix?id=${id}`)
    },
    async createAdasLinks(data) {
      return await api.post('adasmatrix/createAdasLinks', data)
    },
    async importMakeMatrixLinks(data) {
      return await api.post('adasmatrix/importMakeMatrixLinks', data)
    },
    async updateAdasLinks(data) {
      return await api.post('adasmatrix/updateAdasLinks', data)
    },
    async moveAdasMakeMatrix(data) {
      return await api.get(`adasmatrix/moveAdasMakeMatrix?id=${data.id}&to=${data.to}`)
    },
    async getMakeExceptionLookups(data) {
      this.loading.makeExceptionLookups = true
      this.makeExceptionLookups = []
      let results = await api.get(
        `adasmatrix/getMakeExceptionLookups?make=${data.make}&adasChecklistMatrix=&adasChecklistMatrixName=${data.adasChecklistMatrixName}`
      )
      this.loading.makeExceptionLookups = false
      if (results) {
        if (results !== '') {
          this.makeExceptionLookups = results
        }
      }
      return this.makeExceptionLookups
    },
    async getModelVariability(id) {
      let results = await api.get(`adasmatrix/vehicleChecklistMatrixVehicleModel?adasChecklistMatrixVehicle=${id}`)
      if (results) {
        if (results !== '') {
          this.adasmakematrix.models = results
        }
      }
      return results
    },
    async saveModelVariability(data) {
      return await api.post('adasmatrix/saveVehicleChecklistMatrixVehicleModel', data)
    },
    async saveAdasMatrixInfoLookup(data) {
      let results = await api.post('adasmatrix/saveAdasMatrixInfoLookup', data)
      if (results) {
        this.adasmatrixinfolookup.adasChecklistMatrixInfoLookup = parseInt(results)
        this.adasmatrixinfolookup.id = parseInt(results)
      }
      return results
    },
    async importMakeMatrixKeywords(data) {
      return await api.post('adasmatrix/importMakeMatrixKeywords', data)
    },
    async getMakeExceptions(id) {
      this.loading.makeExceptions = true
      this.makeExceptions = []
      let results = await api.get(`adasmatrix/getAdasMakeExclusions?id=${id}`)
      this.loading.makeExceptions = false
      if (results) {
        if (results !== '') {
          this.makeExceptions = results
        }
      }
      return this.makeExceptions
    },
    async getAdasMatrixInfoLookup(id) {
      this.loading.adasmatrixinfolookup = true
      this.adasmatrixinfolookup = null
      let results = await api.get(`adasmatrix/getAdasMatrixInfoLookup?id=${id}`)
      this.loading.adasmatrixinfolookup = false
      if (results) {
        if (results !== '') {
          this.adasmatrixinfolookup = results
        }
      }
      return this.adasmatrixinfolookup
    },
    async getAdasMatrixInfoLookups(options) {
      this.loading.adasmatrixinfolookups = true
      this.adasmatrixinfolookups = []
      let results = await api.get('adasmatrix/getAdasMatrixInfoLookups', options)
      this.loading.adasmatrixinfolookups = false
      if (results) {
        if (results !== '') {
          this.adasmatrixinfolookups = results
        }
      }
      return this.adasmatrixinfolookups
    },
    async deleteAdasMatrixInfoLookup(id) {
      return await api.get(`adasmatrix/deleteAdasMatrixInfoLookup?id=${id}`)
    },
    async decodeVin(vin) {
      this.loading.decodedVin = true
      this.decodedVin = null
      let results = await api.get(`data/neoDecode?vin=${vin}`)
      this.loading.decodedVin = false
      if (results) {
        if (results !== '') {
          this.decodedVin = results
        }
      }
      return this.decodedVin
    },
    async pushMatrixItems(data) {
      return await api.post('adasmatrix/pushMatrixItems', data)
    },
    async testMatrixItems(data) {
      return await api.post('adasmatrix/testMatrixItems', data)
    },
    async fetchLinksByVehicle(data) {
      // Export: LINKS
      this.links = null
      let results = await api.post('adasmatrix/exportLinksByVehicle', data)
      if (results) {
        try {
          this.links = results
          if (Array.isArray(this.links)) {
            this.links.forEach((element) => {
              if (element.links) {
                if (element.links !== null) {
                  try {
                    element.links = JSON.parse(element.links)
                  } catch (e) {
                    element.links = []
                  }
                }
              }
            })
          } else {
            this.links = results
            if (this.links.links) {
              if (this.links.links !== null) {
                try {
                  this.links.links = JSON.parse(this.links.links)
                } catch (e) {
                  this.links.links = []
                }
              }
            }
          }
        } catch (e) {
          console.log('Error (adas > mutations > Set Links)', e)
        }
      }
      return results
    },
    async checklistMatrixVehicleKeywordsTriggersExport(columns) {
      // Export: KEYWORDS
      this.matrixKeywordsTriggers = []
      let results = await api.get(`adasmatrix/checklistMatrixVehicleKeywordsTriggersExport?columns=${columns}`)
      if (results) {
        if (results !== '') {
          this.matrixKeywordsTriggers = results
        }
      }
      return results
    },
    async checklistMatrixAdasExport(isInactive) {
      // Export: ADAS MATRIX
      this.matrixAdas = []
      let results = await api.get(`adasmatrix/checklistMatrixExport?isInactive=${isInactive}`)
      if (results) {
        if (results !== '') {
          this.matrixAdas = results
        }
      }
      return results
    },
    async checklistMatrixItemExport(isInactive) {
      // Export: ADAS MATRIX
      this.matrixAdasItems = []
      let results = await api.get(`adasmatrix/checklistMatrixItemExport?isInactive=${isInactive}`)
      if (results) {
        if (results !== '') {
          this.matrixAdasItems = results
        }
      }
      return results
    },
    async checklistMatrixVehicleExport(isInactive) {
      // Export: VEHICLE MATRIX
      this.matrixVehicle = []
      let results = await api.get(`adasmatrix/checklistMatrixVehicleExport?isInactive=${isInactive}`)
      if (results) {
        if (results !== '') {
          this.matrixVehicle = results
        }
      }
      return results
    },
    async checklistMatrixAdasInfoExport(data) {
      // Export: ADAS MATRIX INFO
      this.matrixAdasInfo = []
      let results = await api.get(
        `adasmatrix/checklistMatrixAdasInfoExport?source=${data.source}&isInactive=${data.isInactive}&vehicleMake=${data.vehicleMake}`
      )
      if (results) {
        if (results !== '') {
          this.matrixAdasInfo = results
        }
      }
      return results
    },
    async systemsExport(isInactive) {
      // Export: SYSTEMS
      this.systems = []
      let results = await api.get(`adasmatrix/systemsExport?isInactive=${isInactive}`)
      console.log('Got Systems', results)
      if (results) {
        if (results !== '') {
          this.systems = results
        }
      }
      return results
    },
    async locationsExport(isInactive) {
      // Export: LOCATIONS
      this.locations = []
      let results = await api.get(`adasmatrix/locationsExport?isInactive=${isInactive}`)
      if (results) {
        if (results !== '') {
          this.locations = results
        }
      }
      return results
    },
    async calibrationsExport(isInactive) {
      // Export: CALIBRATION SERVICES
      this.calibrations = []
      let results = await api.get(`adasmatrix/calibrationsExport?isInactive=${isInactive}`)
      if (results) {
        if (results !== '') {
          this.calibrations = results
        }
      }
      return results
    },
    async exclusionsExport(isInactive) {
      // Export: EXCLUSIONS
      this.exclusions = []
      let results = await api.get(`adasmatrix/exclusionsExport?isInactive=${isInactive}`)
      if (results) {
        if (results !== '') {
          this.exclusions = results
        }
      }
      return results
    },
    async recommendationsExport(isInactive) {
      // Export: REPORT RECOMMENDATIONS
      this.reportRecommendations = []
      let results = await api.get(`adasmatrix/recommendationsExport?isInactive=${isInactive}`)
      if (results) {
        if (results !== '') {
          this.reportRecommendations = results
        }
      }
      return results
    },
    async noScrubListExport() {
      // Export: NO SCRUB LIST
      this.noScrubList = []
      let results = await api.get('adasmatrix/noScrubListExport')
      if (results) {
        if (results !== '') {
          this.noScrubList = results
        }
      }
      return results
    },
    async importMatrixOthers(data) {
      return await api.post('adasmatrix/importMatrixOthers', data)
    },
    async getRecommendations() {
      this.loading.reportRecommendations = true
      this.reportRecommendations = []
      let results = await api.get(`adasmatrix/getReportRecommendations`)
      this.loading.reportRecommendations = false
      if (results) {
        if (results !== '') {
          this.reportRecommendations = results
        }
      }
      console.log('Got Report Recommendations', this.reportRecommendations)
      return this.reportRecommendations
    },
    async deleteRecommendation(id) {
      if (id < 0) {
        return null
      }
      return await api.get(`adasmatrix/removeReportRecommendation?reportRecommendation=${id}`)
    },
    async saveRecommendation() {
      let data = JSON.parse(JSON.stringify(this.reportRecommendation))
      data.systems = JSON.stringify(data.systems)
      data.makes = JSON.stringify(data.makes)
      return await api.post('adasmatrix/saveReportRecommendation', data)
    },
    async previewDifferences(data) {
      this.differences = []
      this.loading.differences = true
      let results = await api.post('adasmatrix/compare', data)
      if (results) {
        if (results !== '') {
          this.differences = results
        }
      }
      this.loading.differences = false
      console.log('Got Differences', this.differences)
      return results
    },
    resetBrokenLinks() {
      this.brokenLinks = []
    },
    async getBrokenLinks(apps) {
      this.brokenLinks = []
      // accepts an array of applications (or a single one)
      const appList = (Array.isArray(apps) ? apps : [apps]).filter((x) => x)
      if (appList.length === 0) {
        return this.brokenLinks
      }
      this.loading.brokenLinks = true
      let results = await api.get(`adasmatrix/getBrokenLinks?appList=${encodeURIComponent(appList.join(','))}&grouped=true`)
      if (results && Array.isArray(results)) {
        this.brokenLinks = results
      }
      this.loading.brokenLinks = false
      console.log('Got Broken Links', this.brokenLinks)
      return this.brokenLinks
    },
    // ALLDATA replacement links for a broken one. The application the link was reported
    // from has to travel with the request - the service routes to that app's ALLDATA account.
    async getLinksByTypeAndSearchTerm(data) {
      if (!data.carid || !data.searchTerm) {
        return []
      }
      let params = new URLSearchParams({
        app: data.source || '',
        carid: data.carid,
        searchFor: data.searchTerm,
        itype: data.itype || ''
      })
      return await api.get(`adasmatrix/searchAlldataLinks?${params.toString()}`)
    },
    async saveBrokenLink(data) {
      this.loading.brokenLink = true
      try {
        return await api.post('adasmatrix/saveBrokenLink', data)
      } finally {
        this.loading.brokenLink = false
      }
    },
    async getLinksManage(options) {
      let results = await api.get('adasmatrix/getLinksManage', options)
      return results && Array.isArray(results.items) ? results.items : []
    },
    async getLinkManage(id) {
      let results = await api.get(`adasmatrix/getLinkManage?adasLinks=${id}`)
      return results && results !== '' ? results : null
    },
    async saveLinkManage(data) {
      return await api.post('adasmatrix/saveLinkManage', { adasLinks: data.adasLinks, links: data.links })
    },
    updateNoScrubItem(data) {
      switch (data.name) {
        case 'new':
          this.noScrubItem = JSON.parse(JSON.stringify(newNoScrubItem))
          break
        case 'vehicleMake':
          this.noScrubItem.vehicleMake = parseInt(data.value)
          break
        case 'vehicleModel':
          this.noScrubItem.vehicleModel = data.value
          break
        case 'model':
          this.noScrubItem.model = data.value
          break
        case 'yearStart':
          this.noScrubItem.yearStart = parseInt(data.value)
          break
        case 'yearEnd':
          this.noScrubItem.yearEnd = parseInt(data.value)
          break
        case 'reason':
          this.noScrubItem.reason = data.value
          break
        case 'isInactive':
          this.noScrubItem.isInactive = data.value
          break
      }
    },
    getNoScrubItem(id) {
      this.noScrubItem = null
      console.log('Looking for No Scrub Item', id)
      if (this.noScrubList) {
        let found = this.noScrubList.find((x) => parseInt(x.adasNoScrubList) === parseInt(id))
        if (found) {
          this.noScrubItem = found
        }
      }
      console.log('Found No Scrub Item', this.noScrubItem)
    },
    async getNoScrubList(options) {
      this.noScrubList = []
      this.noscrublisting = false
      let results = await api.get('adasmatrix/getAdasNoScrubList', options)
      if (results) {
        if (results !== '') {
          this.noScrubList = results
        }
      }
      this.noscrublisting = false
      console.log('Got No Scrub List', this.noScrubList)
      return results
    },
    async saveNoScrubItem(data) {
      return await api.post('adasmatrix/saveAdasNoScrubList', data)
    },
    async deleteNoScrubItem(id) {
      let results = await api.get(`adasmatrix/deleteAdasNoScrubList?id=${id}`)
      return results
    },
    async calibrationPricingExport() {
      this.calibrationPricing = []
      let results = await api.get('adasmatrix/exportCalibrationPricing')
      if (results) {
        if (results !== '') {
          this.calibrationPricing = results
        }
      }
      return results
    },
    async getCalibrationPricing(id) {
      this.calibrationPricing = []
      this.loading.calibrationPricing = false
      let results = await api.get(`adasmatrix/getCalibrationPricing?calibrationType=${id}`)
      if (results) {
        if (results !== '') {
          this.calibrationPricing = results
        }
      }
      this.loading.calibrationPricing = false
      console.log('Got Calibration Pricing', this.calibrationPricing)
      return results
    },
    async saveCalibrationPricing(data) {
      return await api.post('adasmatrix/saveCalibrationPricing', data)
    },
    async reorderAdasMatrixInfoLookups(data) {
      let results = await api.post('adasmatrix/reorderAdasMatrixInfoLookups', data)
      return results
    },
    async getCalibrationSubOptionsForMatrix(data) {
      console.log("Posting Data:", data)
      return await api.post('adasmatrix/getCalibrationSubOptionsForMatrix', data)
    },
  }
})
